import { NgModule } from '@angular/core';
import { EventCardComponent } from './event-card/event-card';
import {IonicModule} from "ionic-angular";
import { TabberComponent } from './tabber/tabber';
import { SearchBarComponent } from './search-bar/search-bar';
@NgModule({
	declarations: [EventCardComponent,
    TabberComponent,
    SearchBarComponent],
	imports: [
	  IonicModule
  ],
	exports: [EventCardComponent,
    TabberComponent,
    SearchBarComponent]
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/components.module.ts